/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';

/**
 * 
 * @export
 * @interface BillingPricingProduct
 */
export interface BillingPricingProduct {
    /**
     * 
     * @type {string}
     * @memberof BillingPricingProduct
     */
    product: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillingPricingProduct
     */
    isActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof BillingPricingProduct
     */
    vatRate: number;
    /**
     * 
     * @type {Amount}
     * @memberof BillingPricingProduct
     */
    unitPrice: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof BillingPricingProduct
     */
    vatAmount: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof BillingPricingProduct
     */
    totalAmount: Amount;
}

/**
 * Check if a given object implements the BillingPricingProduct interface.
 */
// @ts-ignore
export function instanceOfBillingPricingProduct(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "product" in value;
    isInstance = isInstance && "isActive" in value;
    isInstance = isInstance && "vatRate" in value;
    isInstance = isInstance && "unitPrice" in value;
    isInstance = isInstance && "vatAmount" in value;
    isInstance = isInstance && "totalAmount" in value;

    return isInstance;
}

// @ts-ignore
export function BillingPricingProductFromJSON(json: any): BillingPricingProduct {
    return BillingPricingProductFromJSONTyped(json, false);
}

// @ts-ignore
export function BillingPricingProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingPricingProduct {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product': json['product'],
        'isActive': json['is_active'],
        'vatRate': json['vat_rate'],
        'unitPrice': AmountFromJSON(json['unit_price']),
        'vatAmount': AmountFromJSON(json['vat_amount']),
        'totalAmount': AmountFromJSON(json['total_amount']),
    };
}

// @ts-ignore
export function BillingPricingProductToJSON(value?: BillingPricingProduct | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product': value.product,
        'is_active': value.isActive,
        'vat_rate': value.vatRate,
        'unit_price': AmountToJSON(value.unitPrice),
        'vat_amount': AmountToJSON(value.vatAmount),
        'total_amount': AmountToJSON(value.totalAmount),
    };
}

